import { Radio } from 'antd';
import ContractDriverLicenseType, { allCases, name } from '@/components/organisms/contract/ContractDriverLicenseType';

type ContractDriverLicenseTypeSelectorProps = {
  defaultSelected?: ContractDriverLicenseType;
};

const ContractDriverLicenseTypeSelector = ({ defaultSelected }: ContractDriverLicenseTypeSelectorProps) => {
  return (
    <Radio.Group
      name="driverLicenseSelector"
      defaultValue={defaultSelected ?? allCases.first()}
      options={allCases.map((type) => ({
        label: name(type),
        value: type,
      }))}
    />
  );
};

ContractDriverLicenseTypeSelector.defaultProps = {
  defaultSelected: ContractDriverLicenseType.CLASS_1_ORDINARY,
};

export default ContractDriverLicenseTypeSelector;
